<template>
  <dialog-v2
    :show="show"
    :title="title"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex :md4="showTypes" :md6="!showTypes">
          <v-text-field
            v-model="form.name"
            v-validate="'required'"
            data-vv-name="name"
            data-vv-scope="ivrTemplate"
            data-vv-as="nombre"
            color="black"
            label="Nombre"
            :error-messages="errors.collect('ivrTemplate.name')"/>
        </v-flex>
        <v-flex v-if="showTypes" md4 pl-4>
          <v-select
            v-model="form.type"
            :items="types"
            label="Tipo"
            color="black" />
        </v-flex>
        <v-flex :md4="showTypes" :md6="!showTypes" pl-4>
          <v-select
            v-model="form.voice"
            :items="voices"
            label="Voz"
            color="black"
            autocomplete/>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    newIvr: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default() {
        return {
          name: '',
          type: '',
          voice: '',
        };
      },
    },
    showTypes: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    DialogV2,
  },
  data() {
    const emptyForm = {
      name: '',
      type: '',
      voice: '',
    };
    return {
      emptyForm,
      form: {
        ...emptyForm,
      },
    };
  },
  methods: {
    save() {
      this.$validator.validateAll('ivrTemplate').then((validation) => {
        if (validation) {
          this.$emit('save', this.form);
        }
      });
    },
    clearErrors() {
      Object.keys(this.form).forEach((key) => {
        this.$validator.errors.remove(key, 'ivrTemplate');
      });
    },
  },
  computed: {
    types() {
      const result = [
        {
          value: 'sale',
          text: 'Ventas',
        },
      ];

      if (this.newIvr) {
        result.push({
          value: 'plain',
          text: 'Plano',
        });
      }

      return result;
    },
    voices() {
      if (!this.newIvr) {
        return [
          { value: 'lupe', text: 'Lupita' },
          { value: 'ramiro', text: 'Ramiro' },
        ];
      }

      return [
        { value: 'es_MX-Yahir', text: 'Yahir (MX)' },
        { value: 'es_MX-elena', text: 'Elena (MX)' },
        { value: 'es_MX-maney', text: 'Maney (MX)' },
        { value: 'es_MX-claude-high', text: 'Claude (MX)' },
        { value: 'es_MX-laurav2', text: 'Laura V2 (MX)' },
        { value: 'es_MX-sorah', text: 'Sorah (MX)' },
      ];
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.form = {
          ...this.data,
        };
        return this.clearErrors();
      }

      setTimeout(() => {
        this.form = {
          ...this.emptyForm,
        };
        this.clearErrors();
      }, 200);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ivr_v2/IvrDialog.vue